<template>
    <div id="invoice">
        <nav class="printableNo">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outermargin printableNo">
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
        </div>
        <div class="invoice-box printable">
            <table cellpadding="0" cellspacing="0">
                <tr class="top">
                <td colspan="4">
                    <table>
                    <tr>
                        <td class="title">
                        <img src="/assets/adpr.png" style="width:100%; max-width:300px;">
                        </td>

                        <td>
                        Facture #123<br> Crée le : 1er janvier, 2019<br> dû: 1er février, 2019
                        </td>
                    </tr>
                    </table>
                </td>
                </tr>

                <tr class="information">
                <td colspan="4">
                    <table>
                    <tr>
                        <td>
                        Jérôme Le Champion<br>38 rue de la Vega<br>75012 Paris
                        </td>

                        <td>
                        Guillaume Eberwein<br>55 bvd Vincent Auriol<br>75013 Paris
                        </td>
                    </tr>
                    </table>
                </td>
                </tr>

                <tr class="heading">
                <td colspan="3">Méthode de paiement</td>
                <td>Carte Bancaire</td>
                </tr>

                <tr class="heading">
                <td>Détail</td>
                <td>Coût unitaire</td>
                <td>Quantité</td>
                <td>Prix</td>
                </tr>

                <tr class="item" v-for="item in items" :key="item.price">
                <td><input v-model="item.description" /></td>
                <td><input type="number" v-model="item.price" />€</td>
                <td><input type="number" v-model="item.quantity" /></td>
                <td>{{ item.price * item.quantity | currency }}€</td>
                </tr>

                <tr>
                <td colspan="4">
                    <button class="btn-add-row printableNo" @click="addRow">Ajouter en ligne</button>
                </td>
                </tr>

                <tr class="total">
                <td colspan="3"></td>
                <td>Total: {{ total | currency }}€</td>
                </tr>
                
                <tr class="top">
                <td colspan="4">
                    <table class="sigPage">
                    <tr>

                        <td>
                        </td>

                        <td class="sigPageTd">
                            <span class="sigPageTxt">Signature :</span>
                            <img :src="sig" style="width:100%; max-width:250px;">
                        </td>
                    </tr>
                    </table>
                </td>
                </tr>

            </table>
        </div>
        <div class="outercircle printableNo">
            <span class="sigBot">Signature :</span>
            <VueSignaturePad  width="400px" height="150px" class="signature" ref="signaturePad" />
            <button class="docBtn" type="button" v-on:click="print()">Valider et enregistrer</button>            
        </div>
    </div>
</template>

<script>
    //import axios from 'axios';
    export default {
        name: 'Invoice',
        data() {
            return {
                Name:"client",
                sig: "/assets/nosignature.png",
                items: [
                    { description: "Intervention 1", quantity: 1, price: 300 },
                    { description: "Intervention 2", quantity: 1, price: 200 }
                ]
            };
        },
        methods:{
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "home" });
            },
            print() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if(isEmpty){
                    alert("Vous devez signer le document pour le valider");
                }
                else{
                    this.sig = data; 
                    setTimeout(function(){
                        window.print();
                    }, 100);
                }
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            chageSketchState(){
                this.isActiveSketch = !this.isActiveSketch;
            },
            backbtn(){
                if(this.$cookie.get('fromQuery') !== ""){
                    this.$router.replace({ name: this.$cookie.get('fromPage'), query: {name: this.$cookie.get('fromQuery')} });
                }
                else{
                    this.$router.replace({ name: this.$cookie.get('fromPage') });
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "client"){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    //this.getIntervention();
                }
            },
            addRow() {
                this.items.push({ description: "", quantity: 1, price: 0 });
            }
        },
        mounted(){
            this.getCookies();
        },
        computed: {
            total() {
                return this.items.reduce(
                    (acc, item) => acc + item.price * item.quantity,
                    0
                );
            }
        },
        filters: {
            currency(value) {
                return value.toFixed(2);
            }
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #invoice {
        background-color: #F0F0F0;
        margin: auto;
        border:none;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        font-size: 30px;
        margin-top:80px;
        margin-left:50px;
        background-color: #F0F0F0;
    }
    .invoice-box {
        width: 800px;
        height: 1030px;
        margin: auto;
        padding: 30px;
        margin-bottom:20px;
        border: 1px solid #eee;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
        font-size: 16px;
        line-height: 24px;
        font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
        color: #555;
        background-color: #FFFFFF;
    }

    .invoice-box table {
        width: 100%;
        line-height: inherit;
        text-align: left;
    }

    .invoice-box table td {
        padding: 5px;
        vertical-align: top;
    }

    .invoice-box table tr td:nth-child(n + 2) {
        text-align: right;
    }

    .invoice-box table tr.top table td {
        padding-bottom: 20px;
    }

    .invoice-box table tr.top table td.title {
        font-size: 45px;
        line-height: 45px;
        color: #333;
    }

    .invoice-box table tr.information table td {
        padding-bottom: 40px;
    }

    .invoice-box table tr.heading td {
        background: #eee;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
    }

    .invoice-box table tr.details td {
        padding-bottom: 20px;
    }

    .invoice-box table tr.item td {
        border-bottom: 1px solid #eee;
    }

    .invoice-box table tr.item.last td {
        border-bottom: none;
    }

    .invoice-box table tr.item input {
        padding-left: 5px;
    }

    .invoice-box table tr.item td:first-child input {
        margin-left: -5px;
        width: 100%;
    }

    .invoice-box table tr.total td:nth-child(2) {
        border-top: 2px solid #eee;
        font-weight: bold;
    }

    .invoice-box input[type="number"] {
        width: 60px;
    }

    @media only screen and (max-width: 600px) {
      .invoice-box table tr.top table td {
        width: 100%;
        display: block;
        text-align: center;
      }

      .invoice-box table tr.information table td {
        width: 100%;
        display: block;
        text-align: center;
      }
    }

    /** RTL **/
    .rtl {
        direction: rtl;
        font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
    }

    .rtl table {
        text-align: right;
    }

    .rtl table tr td:nth-child(2) {
        text-align: left;
    }
    .sigPage{
        margin-top:50px !important;
    }
    .sigPageTxt{
        display: inline-block;
        vertical-align: middle;
        position: absolute;
        top:20%;
        right:250px;
    }
    .sigPageTd{
        position: relative;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
        width: 800px;
        margin:auto;
        position: relative;
    }
    .docBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        margin:0px;
        margin-bottom:50px;
        margin-right:100px;
        width: 200px;
        position: absolute;
        top: 50%;
        right: 0px;
    }
    .signature{
        display: inline-block;
        border: 2px solid;
        border-color:#888;
        background-color: white;

    }
    .sigBot{
        font-family: 'BenchNine', sans-serif;
        display: block;
        font-size: 18px;
    }
    @media print {
        .printableNo {display:none;}
        input{
            border: none;
        }
        .invoice-box {
            border:none;
            box-shadow: none;
        }
    }
    @page { size: auto; margin: 0mm; }
</style>